import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthStateService } from '@betrail-libs/auth-state';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HasRoleGuard implements CanActivate {
  constructor(private authStateService: AuthStateService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authStateService
      .hasOneOfRoles(route.data.roles)
      .pipe(map(result => result || this.router.createUrlTree(['/home'])));
  }
}
